<template>
  <div class="file-table">
    <!--    <div class="file-table-title">Files</div>-->
    <b-tabs size="is-medium" type="is-toggle" expanded multiline>
      <b-tab-item label="Plans" v-if="files.plans">
        <div v-if="files.plans.length <= 0">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">No plans uploaded for this project</p>
          </div>
        </div>
        <div v-else class="table-container">
          <b-table :data="files.plans"
                   striped
                   paginated
                   hoverable
                   per-page="8"
                   ref="table"
                   aria-next-label="Next page"
                   aria-previous-label="Previous page"
                   aria-page-label="Page"
                   aria-current-label="Current page"
                   pagination-position="bottom"
          >
            <b-table-column label="Name" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div class="cell-element">
                <file-icon v-if="!deviceIsMobile" :file="props.row"></file-icon>
                {{ props.row.name }}
              </div>
            </b-table-column>
            <b-table-column label="Uploaded" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div>
                {{ props.row.modifiedTime | dateLong }}
              </div>
            </b-table-column>
            <b-table-column label=" " :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div @click.prevent="downloadFile(props.row.id, props.row.name)">
                <fa v-if="!isLoading(props.row.id)" icon="cloud-arrow-down"/>
                <fa v-else icon="spinner" spin/>
              </div>
            </b-table-column>
          </b-table>
        </div>
      </b-tab-item>
      <b-tab-item label="Annotated Plans" v-if="files.annotatedPlans">
        <div v-if="files.annotatedPlans.length <= 0">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">No annotated plans uploaded for this project</p>
          </div>
        </div>
        <div v-else class="table-container">
          <b-table :data="files.annotatedPlans"
                   striped
                   paginated
                   hoverable
                   per-page="8"
                   ref="table"
                   aria-next-label="Next page"
                   aria-previous-label="Previous page"
                   aria-page-label="Page"
                   aria-current-label="Current page"
                   pagination-position="bottom"
          >
            <b-table-column label="Name" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div class="cell-element">
                <file-icon v-if="!deviceIsMobile" :file="props.row"></file-icon>
                {{ props.row.name }}
              </div>
            </b-table-column>
            <b-table-column label="Uploaded" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div>
                {{ props.row.modifiedTime | dateLong }}
              </div>
            </b-table-column>
            <b-table-column label=" " :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div @click.prevent="downloadFile(props.row.id, props.row.name)">
                <fa v-if="!isLoading(props.row.id)" icon="cloud-arrow-down"/>
                <fa v-else icon="spinner" spin/>
              </div>
            </b-table-column>
          </b-table>
        </div>
      </b-tab-item>
      <b-tab-item label="Builder" v-if="files.builderReports">
        <div v-if="Object.keys(files.builderReports).length <= 0">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">No reports uploaded for this project yet</p>
          </div>
        </div>
        <div v-else class="dropdown-container">
          <b-dropdown size="is-medium" aria-role="list" class="is-align-self-flex-end mb-4">
            <template #trigger="{ active }">
              <b-button
                  size="is-medium"
                  :label="selectedBuilderPlot ? 'Plot - ' + title(selectedBuilderPlot) : 'Select Plot'"
                  type="is-accent"
                  icon-right="caret-down">
              </b-button>
            </template>

            <b-dropdown-item
                v-for="(reports, index) in files.builderReports"
                :key="index"
                @click="selectedBuilderPlot = index"
            >
              Plot - {{ index | title }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="table-container" v-if="selectedBuilderPlot && files.builderReports[selectedBuilderPlot] && files.builderReports[selectedBuilderPlot].length > 0">
          <b-table :data="files.builderReports[selectedBuilderPlot]"
                   striped
                   paginated
                   hoverable
                   per-page="8"
                   ref="table"
                   aria-next-label="Next page"
                   aria-previous-label="Previous page"
                   aria-page-label="Page"
                   aria-current-label="Current page"
                   pagination-position="bottom"
          >
            <b-table-column label="File Name" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div class="cell-element">
                <file-icon v-if="!deviceIsMobile" :file="props.row"></file-icon>
                {{ props.row.name }}
              </div>
            </b-table-column>
            <b-table-column label="Uploaded" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div>
                {{ props.row.modifiedTime | dateLong }}
              </div>
            </b-table-column>
            <b-table-column label=" " :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div @click.prevent="downloadFile(props.row.id, props.row.name)">
                <fa v-if="!isLoading(props.row.id)" icon="cloud-arrow-down"/>
                <fa v-else icon="spinner" spin/>
              </div>
            </b-table-column>
          </b-table>
        </div>
        <div v-else-if="Object.keys(files.builderReports).length > 1">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">Please select a plot using the above dropdown to see the
              reports for it</p>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Client" v-if="files.clientReports">
        <div v-if="Object.keys(files.clientReports).length <= 0">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">No client reports uploaded for this project yet</p>
          </div>
        </div>
        <div v-else class="dropdown-container">
          <b-dropdown size="is-medium" aria-role="list" class="is-align-self-flex-end mb-4">
            <template #trigger="{ active }">
              <b-button
                  size="is-medium"
                  :label="selectedClientPlot ? 'Plot - ' + title(selectedClientPlot) : 'Select Plot'"
                  type="is-accent"
                  icon-right="caret-down">
              </b-button>
            </template>

            <b-dropdown-item
                v-for="(reports, index) in files.clientReports"
                :key="index"
                @click="selectedClientPlot = index"
            >
              Plot - {{ index | title }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="table-container" v-if="selectedClientPlot && files.clientReports[selectedClientPlot] && files.clientReports[selectedClientPlot].length > 0">
          <b-table :data="files.clientReports[selectedClientPlot]"
                   striped
                   paginated
                   hoverable
                   per-page="8"
                   ref="table"
                   aria-next-label="Next page"
                   aria-previous-label="Previous page"
                   aria-page-label="Page"
                   aria-current-label="Current page"
                   pagination-position="bottom"
          >
            <b-table-column label="File Name" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div class="cell-element">
                <file-icon v-if="!deviceIsMobile" :file="props.row"></file-icon>
                {{ props.row.name }}
              </div>
            </b-table-column>
            <b-table-column label="Uploaded" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div>
                {{ props.row.modifiedTime | dateLong }}
              </div>
            </b-table-column>
            <b-table-column label=" " :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div @click.prevent="downloadFile(props.row.id, props.row.name)">
                <fa v-if="!isLoading(props.row.id)" icon="cloud-arrow-down"/>
                <fa v-else icon="spinner" spin/>
              </div>
            </b-table-column>
          </b-table>
        </div>
        <div v-else-if="Object.keys(files.clientReports).length > 1">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">Please select a plot using the above dropdown to see the
              reports for it</p>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Branch" v-if="files.branchReports">
        <div v-if="Object.keys(files.branchReports).length <= 0">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">No branch reports uploaded for this project yet</p>
          </div>
        </div>
        <div v-else class="dropdown-container">
          <b-dropdown size="is-medium" aria-role="list" class="is-align-self-flex-end mb-4">
            <template #trigger="{ active }">
              <b-button
                  size="is-medium"
                  :label="selectedBranchPlot ? 'Plot - ' + title(selectedBranchPlot) : 'Select Plot'"
                  type="is-accent"
                  icon-right="caret-down">
              </b-button>
            </template>

            <b-dropdown-item
                v-for="(reports, index) in files.branchReports"
                :key="index"
                @click="selectedBranchPlot = index"
            >
              Plot - {{ index | title }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="table-container" v-if="selectedBranchPlot && files.branchReports[selectedBranchPlot] && files.branchReports[selectedBranchPlot].length > 0">
          <b-table :data="files.branchReports[selectedBranchPlot]"
                   striped
                   paginated
                   hoverable
                   per-page="8"
                   ref="table"
                   aria-next-label="Next page"
                   aria-previous-label="Previous page"
                   aria-page-label="Page"
                   aria-current-label="Current page"
                   pagination-position="bottom"
          >
            <b-table-column label="File Name" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div class="cell-element">
                <file-icon v-if="!deviceIsMobile" :file="props.row"></file-icon>
                {{ props.row.name }}
              </div>
            </b-table-column>
            <b-table-column label="Uploaded" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div>
                {{ props.row.modifiedTime | dateLong }}
              </div>
            </b-table-column>
            <b-table-column label=" " :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div @click.prevent="downloadFile(props.row.id, props.row.name)">
                <fa v-if="!isLoading(props.row.id)" icon="cloud-arrow-down"/>
                <fa v-else icon="spinner" spin/>
              </div>
            </b-table-column>
          </b-table>
        </div>
        <div v-else-if="Object.keys(files.branchReports).length > 1">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">Please select a plot using the above dropdown to see the
              reports for it</p>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Specialist Quotes" v-if="files.externalQuotes">
        <div v-if="Object.keys(files.externalQuotes).length <= 0">
          <div class="notification is-primary">
            <p class="title is-5 primary-font-color has-text-centered">No specialist quotes uploaded for this project</p>
          </div>
        </div>
        <div v-else class="dropdown-container">
          <b-dropdown size="is-medium" aria-role="list" class="is-align-self-flex-end mb-4">
            <template #trigger="{ active }">
              <b-button
                  size="is-medium"
                  :label="selectedExternalQuote ? 'Specialist Quote - ' + title(selectedExternalQuote) : 'Select Specialist Quote'"
                  type="is-accent"
                  icon-right="caret-down">
              </b-button>
            </template>

            <b-dropdown-item
                v-for="(reports, index) in files.externalQuotes"
                :key="index"
                @click="selectedExternalQuote = index"
            >
              Specialist Quote - {{ index | title }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="table-container" v-if="selectedExternalQuote && files.externalQuotes[selectedExternalQuote] && files.externalQuotes[selectedExternalQuote].length > 0">
          <b-table :data="files.externalQuotes[selectedExternalQuote]"
                   striped
                   paginated
                   hoverable
                   per-page="8"
                   ref="table"
                   aria-next-label="Next page"
                   aria-previous-label="Previous page"
                   aria-page-label="Page"
                   aria-current-label="Current page"
                   pagination-position="bottom"
          >
            <b-table-column label="Quote Type" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div>
                {{ selectedExternalQuote | title }}
              </div>
            </b-table-column>
            <b-table-column label="File Name" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div class="cell-element">
                <file-icon v-if="!deviceIsMobile" :file="props.row"></file-icon>
                {{ props.row.name }}
              </div>
            </b-table-column>
            <b-table-column label="Uploaded" :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div>
                {{ props.row.modifiedTime | dateLong }}
              </div>
            </b-table-column>
            <b-table-column label=" " :th-attrs="columnThAttr" :td-attrs="columnTdAttrs" v-slot="props">
              <div @click.prevent="downloadFile(props.row.id, props.row.name)">
                <fa v-if="!isLoading(props.row.id)" icon="cloud-arrow-down"/>
                <fa v-else icon="spinner" spin/>
              </div>
            </b-table-column>
          </b-table>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import FileDownload from "../file-download";
import FileIcon from "../file/icon";
import filters from "../../module/filters";

export default {
  name: 'file-table',
  filters,
  components: {
    FileDownload,
    FileIcon,
  },
  props: {
    files: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedBuilderPlot: null,
      selectedClientPlot: null,
      selectedBranchPlot: null,
      selectedExternalQuote: null,
      loadingFiles: [],
      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Uploaded',
          field: 'modifiedTime',
        }],
    }
  },
  computed: {
    deviceIsMobile() {
      return this.$store.state.device.type === 'mobile';
    },
    project() {
      return this.$store.state.quote.selected.quote;
    },
  },
  watch: {
    selectedClientPlot() {
      if (this.selectedClientPlot) {
        if (this.selectedBuilderPlot !== this.selectedClientPlot) {
          this.selectedBuilderPlot = this.selectedClientPlot;
        }
        if (this.selectedBranchPlot !== this.selectedClientPlot) {
          this.selectedBranchPlot = this.selectedClientPlot;
        }
      }
    },
    selectedBuilderPlot() {
      if (this.selectedBuilderPlot) {
        if (this.selectedClientPlot !== this.selectedBuilderPlot) {
          this.selectedClientPlot = this.selectedBuilderPlot;
        }
        if (this.selectedBranchPlot !== this.selectedBuilderPlot) {
          this.selectedBranchPlot = this.selectedBuilderPlot;
        }
      }
    },
    selectedBranchPlot() {
      if (this.selectedBranchPlot) {
        if (this.selectedClientPlot !== this.selectedBranchPlot) {
          this.selectedClientPlot = this.selectedBranchPlot;
        }
        if (this.selectedBuilderPlot !== this.selectedBranchPlot) {
          this.selectedBuilderPlot = this.selectedBranchPlot;
        }
      }
    },
  },
  mounted() {
    if (Object.keys(_.get(this.files, 'builderReports', {})).length === 1) {
      this.selectedBuilderPlot = Object.keys(this.files.builderReports)[0];
    }
    if (Object.keys(_.get(this.files, 'clientReports', {})).length === 1) {
      this.selectedClientPlot = Object.keys(this.files.clientReports)[0];
    }
    if (Object.keys(_.get(this.files, 'branchReports', {})).length === 1) {
      this.selectedBranchPlot = Object.keys(this.files.branchReports)[0];
    }
    if (Object.keys(_.get(this.files, 'externalQuotes', {})).length === 1) {
      this.selectedExternalQuote = Object.keys(this.files.externalQuotes)[0];
    }
  },
  methods: {
    title(value) {
      return filters.title(value);
    },
    columnTdAttrs(row, column) {
      let attrs = {};

      attrs.style = {};
      attrs.style['font-size'] = '0.9rem';
      attrs.style['color'] = '#000 !important';
      attrs.style['white-space'] = 'normal';
      attrs.class = ['has-text-centered', 'full-width-on-mobile']

      if (column.label === ' ') {
        attrs.display = 'flex';
        attrs.style['justify-content'] = 'center';
        attrs.style['align-items'] = 'center';
        attrs.style['text-align'] = 'left !important';
        attrs.style['width'] = '50px';
        attrs.class.push('is-full-width-on-mobile');
      }

      if (column.label !== ' ') {
        attrs.style['text-align'] = 'left !important';
        attrs.style['gap'] = '7em !important';
      }

      if (column.label === 'Uploaded') {
        attrs.style['width'] = '180px';
        attrs.class.push('is-full-width-on-mobile');
      }

      if (column.label === 'Name') {
        attrs.style['word-wrap'] = 'break-word';
        attrs.style['overflow-wrap'] = 'break-word';
      }

      if (column.label === 'File Name' || column.label === 'Plot') {
        attrs.style['word-wrap'] = 'break-word';
        attrs.style['overflow-wrap'] = 'break-word';
      }

      return attrs;
    },
    columnThAttr(column) {
      let attrs = {};

      attrs.style = {};
      attrs.style['font-size'] = '1rem';
      attrs.style['background-color'] = '#fff !important';
      attrs.style.color = '#000 !important'

      if (column.label === 'Uploaded') {
        attrs.style['width'] = '140px';
      }

      if (column.label === ' ') {
        attrs.class = 'has-text-centered';
        attrs.style['text-align'] = 'center !important';
      }


      return attrs;
    },
    isLoading(fileId) {
      return this.loadingFiles.includes(fileId);
    },
    async downloadFile(fileId, fileName) {
      try {
        this.loadingFiles.push(fileId);
        const token = _.get(this.project, 'token.brand', null);
        let completeFileName = _.get(this.project, 'ref', '');

        if (this.selectedExternalQuote) {
          completeFileName += ` - ${this.selectedExternalQuote}`;
        }

        completeFileName += ` - ${fileName}`;

        const response = await fetch(`file.php?a=portal/quote&t=${token}&tt=brand&f=${fileId}&name=${completeFileName}`);
        const blob = await response.blob();

        // Create a blob URL
        const url = window.URL.createObjectURL(blob);

        // Create a link element for downloading
        const link = document.createElement('a');
        link.href = url;
        link.download = completeFileName;

        // Simulate a click on the link
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the blob URL after a delay
        setTimeout(() => window.URL.revokeObjectURL(url), 100);

        // Remove the file ID from the loading list
        this.loadingFiles = this.loadingFiles.filter(id => id !== fileId);
      } catch (e) {
        // Handle errors: remove the loading indicator and show an error message
        this.loadingFiles = this.loadingFiles.filter(id => id !== fileId);
        this.$buefy.toast.open({
          message: 'Error downloading file',
          type: 'is-danger',
          duration: 5000,
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.file-table {
  min-height: 550px;

  .cell-element {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }

  .dropdown-container {
    display: grid;
    justify-items: center;
  }

  .table-container {
    overflow-x: hidden;
  }
}
</style>